import { styled } from '@linaria/react';

import { hoverable } from '~theme/snippets';

export const CheckBoxWrapper = styled.label<{ disabled?: boolean }>`
	display: flex;
	flex-flow: row nowrap;
	align-items: center;
	column-gap: var(--gap-x4);
	${hoverable};
	pointer-events: ${({ disabled }) => (disabled ? 'none' : 'all')};
`;

export const CheckboxInput = styled.input`
	position: absolute;
	z-index: -1;
	width: 0;
	height: 0;
	opacity: 0;
	&:not(:checked) + span {
		border-color: var(--color-white-solid);
		background-color: var(--color-grey-7-solid);
		svg {
			opacity: 0;
		}
	}
`;

export const CheckBoxSquare = styled.span`
	display: flex;
	width: 16px;
	height: 16px;
	flex-shrink: 0;
	border: 1px solid var(--color-rose-48-solid);
	border-radius: var(--radius-xxxs);
	background-color: var(--color-rose-48-solid);
	transition: border-color 0.2s ease;
	svg {
		margin: auto;
	}
`;
